/* Load the homepage's actual collective only when motion is appropriate.
   Its rendered homepage portrait remains the no-JS / no-GPU fallback. */
const stage = document.querySelector('[data-borg-code-stage]');
const motion = matchMedia('(prefers-reduced-motion: reduce)');
if (stage && !motion.matches) {
  const observer = new IntersectionObserver((entries) => {
    if (entries.some((entry) => entry.isIntersecting)) {
      observer.disconnect();
      import('./app-code-stage.js').then(({ mountBorgCode }) => mountBorgCode(stage)).catch(() => {
        stage.dataset.webgl = 'off';
      });
    }
  }, { rootMargin: '120px' });
  observer.observe(stage);
}
